module.exports = __webpack_public_path__ + "media/images/shark/Shark5-p-500-a84ccbc70e4ee5d8578219ad3c737555.png";